'use strict';

var SortCustomizationDropdownDirective = function SortCustomizationDropdownDirective(angularHelper) {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/sort-customization-dropdown.html'),
    controller: 'SortCustomizationDropdownController',
    require: '^rmSortCustomization',
    scope: {
      label: '=',
      index: '='
    },
    link: function link($scope, element, attrs, controller) {
      var getCurrentSortColumn = function () {
        function f() {
          $scope.currentSortColumn = controller.getSortColumn();
          angularHelper.triggerDigest($scope);
        }
        f();
        return f;
      }();
      var getSortOptions = function () {
        function f() {
          $scope.setDropdownOptions(controller.getSortColumnOptions());
          angularHelper.triggerDigest($scope);
        }
        f();
        return f;
      }();
      $scope.$on('grid:gridColumnsUpdated', getSortOptions);
      $scope.$on('grid:sortOptionsAdjusted', getSortOptions);
      $scope.$on('grid:sorted', getCurrentSortColumn);
      $scope.$on('grid:sorted', getSortOptions);
      $scope.$on('sortCustomization:resetSortColumns', getCurrentSortColumn);
      $scope.$on('sortCustomization:resetSortColumns', getSortOptions);
      $scope.fireSortColumnChanged = function () {
        controller.fireAdjustSortOptions();
      };
    }
  };
};
SortCustomizationDropdownDirective.$inject = ['AngularHelper'];
module.exports = SortCustomizationDropdownDirective;